<template>
  <ProductDetailComponent />
</template>
<script>
import ProductDetailComponent from "@/components/personalize/product-detail/ProductDetailComponent.vue";
export default {
  components: {
    ProductDetailComponent,
  },
  name: "ProductPersonalize",
};
</script>
<style src="./product.scss" lang="scss" scoped />
